import React, { useEffect, useState } from 'react';
import { IoIosLock } from "react-icons/io";
import { GiTrophyCup, GiBulldozer } from "react-icons/gi";
import { FaHandshakeSimple } from "react-icons/fa6";
import { FaUsers, FaClock, FaTrophy, FaRoad } from 'react-icons/fa';
import { MdConstruction } from 'react-icons/md';

import '../style/Services.css';

const Services = () => {
  const [isVisible, setIsVisible] = useState(false);
  const [hoveredCard, setHoveredCard] = useState(null);

  // Affiche dans la console la carte survolée
  useEffect(() => {
    console.log('Carte survolée :', hoveredCard);
  }, [hoveredCard]);

  useEffect(() => {
    const handleScroll = () => {
      const section = document.querySelector('.services-section');
      if (section) {
        const scrollPosition = window.scrollY + 300;
        const sectionTop = section.offsetTop;
        if (scrollPosition >= sectionTop) {
          setIsVisible(true);
        }
      }
    };
    handleScroll();
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <section id="services" className="services-section">
      <div className="container">
        {/* En-tête */}
        <div className={`section-header ${isVisible ? 'fade-in-up' : 'opacity-0'}`}>
          <span className="section-tag">Nos services</span>
          <h2>Des solutions complètes pour vos chantiers</h2>
          <div className="separator"></div>
          <p>Nous vous accompagnons de la conception à la réalisation de vos projets</p>
        </div>

        {/* Statistiques */}
        <div className={`services-stats ${isVisible ? 'fade-in-up delay-1' : 'opacity-0'}`}>
          <div className="stat-item">
            <div className="stat-icon">
              <FaTrophy />
            </div>
            <div className="stat-number">1+</div>
            <div className="stat-label">Années d'expérience</div>
          </div>
          <div className="stat-item">
            <div className="stat-icon">
              <GiBulldozer />
            </div>
            <div className="stat-number">15+</div>
            <div className="stat-label">Engins disponibles</div>
          </div>
          <div className="stat-item">
            <div className="stat-icon">
              <FaUsers />
            </div>
            <div className="stat-number">50+</div>
            <div className="stat-label">Clients satisfaits</div>
          </div>
          <div className="stat-item">
            <div className="stat-icon">
              <FaClock />
            </div>
            <div className="stat-number">24/7</div>
            <div className="stat-label">Intervention rapide</div>
          </div>
        </div>

        {/* Grille des services */}
        <div className="services-grid">
          <div 
            className={`service-card ${isVisible ? 'fade-in-up delay-2' : 'opacity-0'}`}
            onMouseEnter={() => setHoveredCard(1)}
            onMouseLeave={() => setHoveredCard(null)}
          >
            <div className="service-image">
              <img 
                src="/img/engins.jpg" 
                alt="Location d'engins"
              />
              <div className="service-overlay">
                <GiBulldozer className="service-icon" />
              </div>
            </div>
            <div className="service-content">
              <h3>Location d'engins et transport des agrégats</h3>
              <p>Bulldozers, pelles hydrauliques, compacteurs, niveleuses, camions bennes et tractopelles à la journée, semaine ou mois.</p>
              <ul className="service-features">
                <li>✅ Avec ou sans opérateur</li>
                <li>✅ Matériels entretenus</li>
                <li>✅ Livraison sur chantier</li>
              </ul>
              <a href="#contact" className="service-btn">Demander un devis</a>
            </div>
          </div>

          <div 
            className={`service-card ${isVisible ? 'fade-in-up delay-3' : 'opacity-0'}`}
            onMouseEnter={() => setHoveredCard(2)}
            onMouseLeave={() => setHoveredCard(null)}
          >
            <div className="service-image">
              <img 
                src="/img/tp.jpg" 
                alt="Travaux publics"
              />
              <div className="service-overlay">
                <FaRoad className="service-icon" />
              </div>
            </div>
            <div className="service-content">
              <h3>Travaux publics</h3>
              <p>Etudes, conception, terrassement, routes, pistes rurales, assainissement et génie civil pour les collectivités et les particuliers.</p>
              <ul className="service-features">
                <li>✅ Terrassement lourd</li>
                <li>✅ Construction de routes</li>
                <li>✅ Assainissement</li>
              </ul>
              <a href="#contact" className="service-btn">Demander un devis</a>
            </div>
          </div>

          <div 
            className={`service-card ${isVisible ? 'fade-in-up delay-4' : 'opacity-0'}`}
            onMouseEnter={() => setHoveredCard(3)}
            onMouseLeave={() => setHoveredCard(null)}
          >
            <div className="service-image">
              <img 
                src="/img/construction.jpg" 
                alt="Construction"
              />
              <div className="service-overlay">
                <MdConstruction className="service-icon" />
              </div>
            </div>
            <div className="service-content">
              <h3>Construction</h3>
              <p>Villas, bâtiments commerciaux et bureaux avec des finitions de qualité et des délais respectés.</p>
              <ul className="service-features">
                <li>✅ Villas d'architecte</li>
                <li>✅ Bâtiments commerciaux</li>
                <li>✅ Finitions haut de gamme</li>
              </ul>
              <a href="#contact" className="service-btn">Demander un devis</a>
            </div>
          </div>
        </div>

        {/* Bandeau de confiance */}
        <div className={`services-trust ${isVisible ? 'fade-in-up delay-5' : 'opacity-0'}`}>
          <p>
            <span className="trust-icon">
              <IoIosLock />
            </span>
            Devis gratuit et sans engagement 
            <span className="trust-separator">|</span>
            <span className="trust-icon">
              <GiTrophyCup />
            </span>
            Garantie décennale 
            <span className="trust-separator">|</span>
            <span className="trust-icon">
              <FaHandshakeSimple />
            </span>
            Transparence totale
          </p>
        </div>
      </div>
    </section>
  );
};

export default Services;